// extracted by mini-css-extract-plugin
module.exports = {"actions":"seance-actions_actions__3nBH1"};